module.exports = __webpack_public_path__ + "img/10787@3x.a60468b3.png";